import { useEffect, useState } from 'react';
import capitalize from 'lodash/capitalize';
import { css, cx } from '@eti/styles';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const linkStyles = css`
  display: block;
`;
const PartnerLogo = _ref => {
  let {
    className,
    collection,
    href,
    id
  } = _ref;
  const [icon, setIcon] = useState(null);
  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      const {
        ReactComponent
      } = await import(`@eti/assets/logos/${collection}/${id}.svg`);
      if (isMounted) {
        setIcon(/*#__PURE__*/_jsx(ReactComponent, {
          className: cx('etiPartnerLogo', className),
          "data-testid": `partner-logo-${id}`,
          role: "img",
          title: `${capitalize(id)}`
        }));
      }
    };
    const init = async () => {
      try {
        await load();
      } catch (err) {
        console.warn(err); // eslint-disable-line no-console
      }
    };
    init();
    return () => {
      isMounted = false;
    };
  }, [className, collection, id]);
  if (!icon) {
    return null;
  }
  if (href) {
    return /*#__PURE__*/_jsx("a", {
      "aria-label": capitalize(id),
      className: cx('etiPartnerLogo__link', linkStyles),
      href: href,
      rel: "noreferrer",
      target: "_blank",
      children: icon
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: icon
  });
};
export default PartnerLogo;
//# sourceMappingURL=PartnerLogo.js.map